import { NavigationGuard } from 'vue-router';

/**
 * If the query params are empty, then we remove them from the query object.
 * @param to - The target Route Object being navigated to.
 * @param from - Route: the current route being navigated away from.
 * @param next - Function
 * @returns The next() function is being returned.
 */
const QUERY_GUARD: NavigationGuard = (to, from, next) => {
   const hasEmptyQueryParams = Object.values(to.query).filter((value) => !value).length > 0;

   if (!hasEmptyQueryParams) return next();

   const query = Object.keys(to.query).reduce((acc, key) => {
      if (!to.query[key]) return acc;
      return { ...acc, [key]: to.query[key] };
   }, {});

   return next({ ...to, query });
};

export default QUERY_GUARD;
